import { render, staticRenderFns } from "./PriceListDetail.vue?vue&type=template&id=0151f9d2&scoped=true&"
import script from "./PriceListDetail.vue?vue&type=script&lang=js&"
export * from "./PriceListDetail.vue?vue&type=script&lang=js&"
import style0 from "./PriceListDetail.vue?vue&type=style&index=0&id=0151f9d2&lang=scss&scoped=true&"
import style1 from "./PriceListDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0151f9d2",
  null
  
)

export default component.exports